// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { OnlineContentCreatorGender } from "../schema";

export function serialize_OnlineContentCreatorGender_internal(value: OnlineContentCreatorGender): unknown {
  return ((value: "MALE" | "FEMALE" | "UNKNOWN"): unknown => {
    return value;
  })(value);
}
export function serialize_OnlineContentCreatorGender(obj: OnlineContentCreatorGender): string {
  return renderJsonWithNumbersAsBigint(serialize_OnlineContentCreatorGender_internal(obj));
}
export function deserialize_OnlineContentCreatorGender_internal(value: unknown): ParserResult<OnlineContentCreatorGender> {
  return ((value: unknown): ParserResult<"MALE" | "FEMALE" | "UNKNOWN"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/OnlineContentCreatorGender]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "MALE":
        return { success: true, value: "MALE" };
      case "FEMALE":
        return { success: true, value: "FEMALE" };
      case "UNKNOWN":
        return { success: true, value: "UNKNOWN" };
      default:
        return { success: false, reason: `[#/components/schemas/OnlineContentCreatorGender]: '${value}' expected to be enum, one of 'MALE, FEMALE, UNKNOWN'.` };
    }
  })(value);
}
export function deserialize_OnlineContentCreatorGender(str: string): ParserResult<OnlineContentCreatorGender> {
  return deserialize_OnlineContentCreatorGender_internal(parseJsonWithNumbersAsBigint(str));
}
